// The copy and project data live here so they can be refined independently of the layout.
export const projects = [{
  id: 'glossary',
  number: '01',
  title: 'Quick Info Glossary',
  category: 'EDUCATION × WEB',
  year: '2024',
  description: '情報Ⅰへの不安を、見て理解できる体験へ。',
  story: '高校生に実際に使ってもらい、声を受けて繰り返し改善。お気に入りやクイズを追加し、学び直しやすい体験を整えました。',
  overview: '共通テスト「情報Ⅰ」を受験する人に向けた用語集Webアプリ。100語以上の用語に詳しい解説と視覚的なデモを用意し、クイズで理解を確かめられる学習体験を、3人チームで開発しました。',
  tags: ['React', 'Firebase'],
  url: 'https://visualwordbook-20b08.web.app/',
  className: 'glossary',
  images: [
    { src: '/images/quick-info-glossary-home.png', width: 1920, height: 1075, alt: 'Quick Info Glossaryのホーム画面。5つの学習カテゴリーと、用語一覧・お気に入り機能。', caption: 'HOME / カテゴリーから探し、気になる用語をお気に入りに。' },
    { src: '/images/quick-info-glossary-demo.png', width: 1918, height: 1034, alt: 'バブルソートのデモ画面。数値を棒で表し、開始・再開、次のステップ、速度調整で動きを確認できる。', caption: 'DEMO / バブルソートの動きを、ステップごとに目で追う。' },
  ],
  awards: {
    event: '技育博2024', names: ['CyberAgent賞', 'CARTA HOLDINGS賞'],
    photos: [
      { src: '/images/gikuhaku-cyberagent.webp', width: 1500, height: 1125, alt: '技育博2024でCyberAgent賞を受賞し、表彰状を持って記念撮影する様子', caption: 'CyberAgent賞' },
      { src: '/images/gikuhaku-carta.webp', width: 1500, height: 1125, alt: '技育博2024でCARTA HOLDINGS賞を受賞し、2枚の表彰状を持って記念撮影する様子', caption: 'CARTA HOLDINGS賞' },
    ],
  },
  highlights: ['100語以上の解説・デモ', '3か月 / 3人開発'],
  caseStudy: {
    headline: '「情報Ⅰが不安」を、\n「見てわかる」に変える',
    facts: [
      { label: '対象ユーザー', value: '共通テスト「情報Ⅰ」の受験者' },
      { label: '制作期間', value: '3か月' },
      { label: '開発体制', value: '3人チーム' },
      { label: '自分の担当', value: 'フロントエンド・チームの指揮' },
    ],
    sections: [
      {
        label: '01 / BACKGROUND', title: '教える現場で出会った、不安と苦手意識',
        paragraphs: [
          '共通テストへの「情報Ⅰ」導入を知り、情報系の大学での学びと教職の経験を生かして、クラウドワークスで情報Ⅰの模試制作に取り組みました。その中で、考え方のコツをつかむことが理解や得点につながると感じました。',
          '一方、家庭教師として接していた生徒や周囲の高校生には、情報Ⅰへの苦手意識や初年度の試験に対する不安がありました。このギャップを、自分なりの学習体験で解消したいと考えたことが開発の出発点です。',
        ],
      },
      {
        label: '02 / DESIGN & IMPLEMENTATION', title: '100語以上に、理解の入口となるデモを',
        paragraphs: [
          'こだわったのは、文字の説明だけでなく、視覚的に理解できること。疑似コードで出題されるアルゴリズムも、教科書の説明だけでは動きを捉えにくいと感じ、登録した100語以上すべてにデモを用意しました。私はフロントエンドとチームの指揮を担当しました。',
          '難しかったのは、動きで表しにくい概念をどう見せるか、そして一度にどこまでの知識を伝えるか。用語ごとに、理解しやすい表現と説明の粒度を考えました。バブルソートでは、数値の比較や入れ替えを目で追い、次のステップへ進めたり速度を変えたりしながら学べます。',
        ],
      },
      {
        label: '03 / USER FEEDBACK', title: '高校生に使ってもらい、学び直せる仕組みへ',
        paragraphs: [
          '実際に高校生に使ってもらい、フィードバックを受けながら改善しました。見直したい用語を残せる「お気に入り」と、用語の内容を理解できたか確かめる「クイズ」を追加しました。',
          '見て理解するだけでなく、気になる用語に戻り、自分の理解を確かめられる学習の流れを整えました。',
        ],
      },
    ],
  },
}, {
  id: 'lab',
  number: '02',
  title: 'Laboratory Website',
  category: 'WEB DESIGN & DEVELOPMENT',
  year: '2026',
  description: '研究室を選ぶ前に、知っておきたかった情報を。',
  story: '研究室での学生の離脱という問題から、事前情報の不足によるミスマッチに着目。学生が研究内容や活動を知り、自分の関心と照らし合わせられるサイトへ。',
  purpose: '研究室と学生のミスマッチを減らすために。',
  status: '開発中',
  overview: '研究室での学生の離脱という問題に着目し、背景を分析する中で、シラバスなどの事前情報の不足による学生と教授のミスマッチを課題と捉えました。会津大学 齋藤・仙波研究室の研究内容、活動、学生向けの情報を伝えるWebサイトを刷新し、学生が自分の関心と研究室の方向性を照らし合わせられることを目指しています。現在も開発中で、ミスマッチの低減効果は今後確かめていきます。',
  tags: ['Next.js', 'Tailwind CSS'],
  url: 'https://www-adl.u-aizu.ac.jp/2026/',
  className: 'lab',
  images: [{ src: '/images/lab-homepage.png', width: 1591, height: 848, alt: '会津大学 齋藤・仙波研究室のホームページ。研究内容や学生向け情報への入口。', caption: 'HOME / 研究室と学生をつなぐホームページ（開発中）。' }]
}, {
  id: 'artrium',
  className: 'artrium',
  number: '03',
  title: 'Artrium',
  concept: 'デザインの先にある、\n「あなた」で選ばれるWebサイト',
  category: 'WEB DESIGN / STUDIO',
  year: '2023',
  description: 'デザインの先にある、「あなた」で選ばれるWebサイト',
  overview: 'Studioを使って制作したランディングページ（LP）をまとめたサイト。ハンドメイド作家のこだわりや、その人らしさが伝わることを大切に、4か月間で15人以上の方のLPを制作しました。',
  facts: [
    { label: '制作期間', value: '4か月' },
    { label: '制作実績', value: '15人以上のLPを制作' },
  ],
  tags: ['Studio', 'LP Design'],
  url: null,
  images: [{ src: '/images/artrium-lp.png', width: 1920, height: 1080, alt: 'Artriumで制作したハンドメイド作家のLP。花のアクセサリー、ビーズ、蝶をモチーフにした3つの制作例。', caption: 'WORKS / ハンドメイド作家のこだわりを伝えるLP制作例。' }],
}, {
  id: 'mail',
  number: '04',
  title: 'QuickProfMail',
  category: 'AI × PRODUCT',
  year: '2025',
  description: '教授とのやり取りを、もっと円滑に。',
  story: '教授との煩雑なやり取りを支援するために開発。メール生成とテンプレート管理を組み合わせ、伝えたい内容をまとめる手間を減らすことを目指しました。',
  overview: 'Gemini APIを活用した、教授とのメール作成を支援するサービス。メール生成とテンプレート管理を組み合わせています。',
  tags: ['Next.js', 'Gemini API', 'Firebase'],
  url: 'https://quickprofmail.web.app/',
  className: 'mail',
  images: [{ src: '/images/quickprofmail.png', width: 1320, height: 786, alt: 'QuickProfMailのエディター画面。テンプレートの作成とメールのプレビュー。', caption: 'EDITOR / テンプレートを作り、メールをプレビュー。' }]
}, {
  id: 'school',
  number: '05',
  title: 'English School Website',
  category: 'CLIENT WORK',
  year: '2023',
  description: '英会話塾の公式Webサイト。',
  overview: '英会話塾との打ち合わせを通じ、要件整理からデザイン、制作まで取り組んだWebサイトです。',
  tags: ['Studio', 'UI/UX Design'],
  url: 'https://green127358.studio.site/'
}, {
  id: 'portfolio',
  number: '06',
  title: 'Personal Portfolio',
  category: 'DESIGN & DEVELOPMENT',
  year: '2026',
  description: 'つくり続ける、その軌跡。',
  overview: 'Web開発、教育、AI・ロボット研究を通じた経験をまとめるポートフォリオです。',
  tags: ['React', 'CSS'],
  url: null
}];
